import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  fetchLiveQA,
  fetchUnpublishedLiveQA,
  publishedUnpublished,
  isimportant,
} from "LiveQAAction";
import { showError, showSuccess } from "ReduxErrorBar";
import Reply from "./qa_reply";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class LiveQAList extends Component {
  constructor(props) {
    super(props);
  }

  changeStatus = () => {
    let {
      liveqa,
      selectedSession,
      selectPublishedType,
      currentPage,
      pageDataLength,
    } = this.props;
    let publish = true;
    if (liveqa && liveqa.ispublished) {
      publish = false;
    }

    let pageNo = currentPage;
    if (pageDataLength == 1 && currentPage != 1) {
      pageNo = pageNo - 1;
    }

    this.props.publishedUnpublished(
      this.props.session,
      liveqa.qaid,
      publish,
      selectedSession,
      (response) => {
        if (response.success) {
          selectPublishedType && selectPublishedType.ispublished == "published"
            ? this.props.showSuccess(
                LocaleStrings.polls_qa_message_liveqa_unpublished
              )
            : this.props.showSuccess(
                LocaleStrings.polls_qa_message_liveqa_published
              );
          this.props.removeCallback(liveqa);
          this.props.pagination(pageNo);
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  important = () => {
    let { liveqa, selectedSession, selectPublishedType } = this.props;
    let imp = true;
    if (liveqa && liveqa.isimportant) {
      imp = false;
    }

    this.props.isimportant(
      this.props.session,
      liveqa.qaid,
      imp,
      selectedSession,
      (response) => {
        if (response.success) {
          // liveqa && liveqa.isimportant
          //   ? this.props.showSuccess("QA question marked as unimporant.")
          //   : this.props.showSuccess("QA question marked as important.");
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  selectionCallback = (liveqa) => {
    // var user = this.props.appUser;
    this.props.checkAndUncheckQA(liveqa);
  };

  render() {
    let { liveqa, selectedQA, dragData } = this.props;

    let checked = false;
    if (liveqa.ispublished) {
      checked = true;
    }
    var iconURL = `../../style/images/custom-icons/compound-shape.svg`;
    if (liveqa.isimportant) {
      iconURL = `../../style/images/custom-icons/compound-shape-copy.svg`;
    }

    // Check check box selected or not
    var index = _.findIndex(selectedQA, function (curqa) {
      return curqa.qaid === liveqa.qaid;
    });
    var selchecked = false;
    if (index >= 0) {
      selchecked = true;
    }

    return (
      <div
        className="row vertical-align-center"
        style={{
          fontWeight: 400,
          color: "rgb(63,68,88)",
          borderTop: "1px solid #e6edf3",
          padding: "10px 0px",
          // cursor: "move",
        }}
      >
        <div
          className="col-md-1"
          // style={{ paddingRight: 0 }}
        >
          <label
            className="custom-container-checkbox"
            // style={{ margin: "10px 0 0 0" }}
          >
            <input
              type="checkbox"
              onChange={() => this.selectionCallback(liveqa)}
              checked={selchecked}
            />
            <span className="checkmark" />
          </label>
        </div>
        <div className="col-lg-6 col-sm-3">
          <div className="d-flex align-items-baseline">
            <div>{dragData}</div>
            {liveqa.question}
          </div>
          <div className="theme-color-text" style={{ paddingLeft: 25 }}>
            {liveqa.questionedby && liveqa.appuser_by_questionedby
              ? liveqa.appuser_by_questionedby.username
              : "Anonymous"}
          </div>
        </div>
        <div className="col-lg-2 col-sm-3">
          <Reply
            qaReply={this.props.liveqa}
            changePub={this.changeStatus}
            important={this.important}
            currentPage={this.props.currentPage}
          />
        </div>
        <div className="col-lg-3 col-sm-5">
          <div className="row">
            <div className="col-md-2">
              <div style={{ textAlign: "left" }}>
                <img
                  className="i-custom-star"
                  onClick={this.important}
                  src={iconURL}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <div className="col-md-5">
              <label className="liveqa-switch-action">
                <input
                  type="checkbox"
                  onChange={this.changeStatus}
                  checked={checked}
                />
                <span className="poll-slider poll-round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    selectedSession: state.selectedSession.resource,
    selectPublishedType: state.selectPublishedType,
  };
};
export default connect(mapStateToProps, {
  fetchLiveQA,
  fetchUnpublishedLiveQA,
  publishedUnpublished,
  isimportant,
  showError,
  showSuccess,
})(LiveQAList);
